<template>
  <div>
    <b-col href="#" class="d-flex justify-content-center pb-3">
      <b-button
        :disabled="disabled"
        v-on:click="$emit('click')"
        class="btn-hover login"
        type="submit"
      >
        {{ texto }}
        <b-spinner v-show="showSpinner" small></b-spinner>
      </b-button>
    </b-col>
  </div>
</template>

<script>
export default {
  name: "ButtonFill",
  props: {
    texto: {
      type: String,
      required: true,
    },
    showSpinner: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.login:hover {
  background-position: 0% !important;
}
.btn-hover.login {
  cursor: pointer;
  background-color: #5928c2;
  background-size: 300% 100%;
  background-position: 100%;
  background-image: linear-gradient(
    247.22deg,
    #5928c2 0%,
    #5928c2 33%,
    #2b195d 66%,
    #7528c2 83.33%,
    #d640f4 98.97%,
    #7528c2 100%
  );
  border-radius: 0px;
  min-width: 180px;
  height: 42px;
  border: none;
  moz-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  -webkit-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}
</style>
